(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-snake-product"] && !Shopify.designMode) return;
  try {
    
  class PlantboxPremiumProduct {
    constructor(section) {
      this.section = section;
      this.thumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
      this.panels = Array.from(section.querySelectorAll('[data-gallery-panel]'));
      this.variantInputs = Array.from(section.querySelectorAll('[data-variant-input]'));
      this.price = section.querySelector('[data-variant-price]');
      this.cards = Array.from(section.querySelectorAll('[data-variant-card]'));
      this.quantity = section.querySelector('[data-quantity] input');
      this.removeMissingSupportImages();
      this.bindGallery();
      this.bindVariants();
      this.bindQuantity();
    }

    removeMissingSupportImages() {
      this.section.querySelectorAll('[data-generated-support-image] img').forEach((image) => {
        image.addEventListener('error', () => {
          const wrapper = image.closest('[data-generated-support-image]');
          if (wrapper) wrapper.remove();
          this.thumbs = Array.from(this.section.querySelectorAll('[data-gallery-thumb]'));
          this.panels = Array.from(this.section.querySelectorAll('[data-gallery-panel]'));
        });
      });
    }

    bindGallery() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.galleryThumb;
          this.thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
          this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.galleryPanel === index));
        });
      });
    }

    bindVariants() {
      this.variantInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.cards.forEach((card) => card.classList.toggle('is-selected', card.contains(input)));
          if (this.price && input.dataset.price) this.price.textContent = input.dataset.price;
        });
      });
    }

    bindQuantity() {
      if (!this.quantity) return;
      this.section.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
        button.addEventListener('click', () => {
          const delta = button.hasAttribute('data-quantity-plus') ? 1 : -1;
          this.quantity.value = Math.max(1, Number(this.quantity.value || 1) + delta);
        });
      });
    }
  }

  document.querySelectorAll('[data-premium-product]').forEach((section) => new PlantboxPremiumProduct(section));

  } catch(e) { console.error(e); }
})();
})();
